export function paymentPeriod(period,offset=0,now=new Date()) {
    if(period==='all'||period==='custom')return {start:'',end:''};
    const day=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'}).format(now);
    const [year,month,date]=day.split('-').map(Number);
    let start,end;
    if(period==='week'){
        start=new Date(Date.UTC(year,month-1,date));start.setUTCDate(start.getUTCDate()-((start.getUTCDay()+6)%7)+offset*7);
        end=new Date(start);end.setUTCDate(end.getUTCDate()+6);
    }else{
        const size=period==='quarter'?3:period==='year'?12:1;
        const first=period==='year'?0:period==='quarter'?Math.floor((month-1)/3)*3:month-1;
        start=new Date(Date.UTC(year,first+offset*size,1));end=new Date(Date.UTC(year,first+(offset+1)*size,0));
    }
    return {start:start.toISOString().slice(0,10),end:end.toISOString().slice(0,10)};
}
